import { Component, OnInit, ChangeDetectionStrategy, signal } from '@angular/core';
import moment from 'moment';
import { IAchievement } from 'src/app/models/api.model';
import { GameService } from 'src/app/state/gameState/game.service';
import _ from 'lodash';
import { take } from 'rxjs/operators';
import { CountriesQuery } from 'src/app/state/countriesState/countries.query';

@Component({
  selector: 'app-achievements-page',
  templateUrl: './achievements.page.html',
  styleUrls: ['./achievements.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AchievementsPage implements OnInit {
  public currentTab = signal(0);
  public achievements = signal<IAchievement[]>([]);
  public badges = signal({ ...initialBadges });

  constructor(
    private gameService: GameService,
    private countryQuery: CountriesQuery
  ) {}

  ngOnInit() {}

  switchTab(tab: number) {
    this.currentTab.set(tab);
  }

  ionViewWillEnter() {
    this.gameService
      .getAchievements()
      .pipe(take(1))
      .subscribe((res) => {
        if (res && res.status === 'Success') {
          this.achievements.set(
            _.orderBy(
              res.data.items,
              (d: IAchievement) =>
                d.actionPoints +
                d.councilPoints +
                d.countryPoints +
                d.alliancePoints,
              ['desc']
            ).slice(0, 5)
          );
          const newBadges = { ...initialBadges };
          res.data.items.forEach((achievement) => {
            newBadges.actionPoints += achievement.actionPoints;
            newBadges.councilPoints += achievement.councilPoints;
            newBadges.countryPoints += achievement.countryPoints;
            newBadges.alliancePoints += achievement.alliancePoints;
            newBadges.badgeDiplomat += this.calcBadge(achievement.badgeDiplomat);
            newBadges.badgeSocialite += this.calcBadge(achievement.badgeSocialite);
            newBadges.badgeTactician += this.calcBadge(achievement.badgeTactician);
            newBadges.badgeDefender += this.calcBadge(achievement.badgeDefender);
            newBadges.badgeMediator += this.calcBadge(achievement.badgeMediator);
            newBadges.badgeNegotiator += this.calcBadge(achievement.badgeNegotiator);
            newBadges.totalNoEmojiTasks += achievement.totalNoEmojiTasks;
            newBadges.totalNoExpertQuizTasks += achievement.totalNoExpertQuizTasks;
            newBadges.totalNoSpotTheCountryTasks += achievement.totalNoSpotTheCountryTasks;
          });
          this.badges.set(newBadges);
        }
      });
  }

  calcBadge(score: number) {
    return score ? 1 : 0;
  }

  parseDate(date: string) {
    return moment(date).format('DD/MM/YYYY');
  }

  parseCountryCode(countryCode: string) {
    return this.countryQuery.selectCountryByCountryCode(countryCode);
  }
}

const initialBadges = {
  actionPoints: 0,
  councilPoints: 0,
  countryPoints: 0,
  alliancePoints: 0,
  badgeDiplomat: 0,
  badgeSocialite: 0,
  badgeTactician: 0,
  badgeDefender: 0,
  badgeMediator: 0,
  badgeNegotiator: 0,
  totalNoEmojiTasks: 0,
  totalNoExpertQuizTasks: 0,
  totalNoSpotTheCountryTasks: 0,
};
